var TileId;
(function (TileId) {
    TileId["CelebrationsTile"] = "celebrationsTile";
    TileId["ClockPunchLink"] = "clockPunchLink";
    TileId["FindShiftsLink"] = "findShiftsLink";
    TileId["FindShiftsTile"] = "findShiftsTile";
    TileId["SchedulingProgressTile"] = "progressTile";
    TileId["JobSearchIngress"] = "jobSearchIngress";
    TileId["LearnHubTile"] = "learnHubTile";
    TileId["MissedPunchTile"] = "missedPunchTile";
    TileId["MyHRDashboardTiles"] = "myhr-dashboard-tiles";
    TileId["MyHRUPTAlertTiles"] = "myhr-upt-alert-tiles";
    TileId["MyHRUPTTiles"] = "myhr-upt-tiles";
    TileId["MyPerformanceTile"] = "myperformance-home";
    TileId["NewsCarousel"] = "newsCarousel";
    TileId["OpenEnrollmentWindowTile"] = "OEWindowTile";
    TileId["PayTile"] = "payTile";
    TileId["PhonetoolSearchTile"] = "phonetoolSearchTile";
    TileId["PreHireExperienceDayOne"] = "prehire-exp-day-one";
    TileId["ProfileTile"] = "profileTile";
    TileId["ReportCovidTile"] = "reportCovidTile";
    TileId["ResourcesTile"] = "resourcesTile";
    TileId["RtoLink"] = "rtoLink";
    TileId["ShoutOutsPrivateProfileTile"] = "shout-outs-private-profile-tile";
    TileId["ShoutOutsPublicProfileTile"] = "shout-outs-public-profile-tile";
    TileId["ShoutOutsTile"] = "ShoutOutsTile";
    TileId["ThisWeekHeader"] = "thisWeekHeader";
    TileId["ThisWeekTile"] = "thisWeekTile";
    TileId["VetLink"] = "vetLink";
    TileId["VtoLink"] = "vtoLink";
    TileId["VtoTile"] = "vtoTile";
    TileId["HvhCareersJobSearch"] = "hvh-careers-job-search";
    TileId["HelloWorldExampleTile"] = "helloWorldExampleTile";
    TileId["TemplatedExampleTile"] = "templatedExampleTile";
    TileId["PersonalizedGreeting"] = "personalizedGreeting";
    TileId["PersonalizedSummary"] = "personalizedSummary";
})(TileId || (TileId = {}));
export default TileId;
//# sourceMappingURL=TileId.js.map